export interface ValidateErrorJSON {
  message: 'Validation failed'
  details: { [name: string]: unknown }
}

export interface SuccessMessage {
  status: 'success'
  message?: string
}

export class ApiError extends Error {
  statusCode: number
  status: number
  isAPIError: boolean = true
  constructor(name: string, statusCode: number, message?: string) {
    super(message)
    this.name = name
    this.statusCode = statusCode
    this.status = statusCode
    if (typeof message === 'string') {
      this.message = message
    }
  }
}
export function CreateSuccessMessage(message?: string): SuccessMessage {
  if (message) {
    return { status: 'success', message: message }
  }
  return { status: 'success' }
}
